import { AnalyticServiceVendor, AnalyticsOptions, ThemisAnalytics } from '@legalshield/frontend-analytics';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './components/App/App';
import envConfig from './config';
import { launchDarklyContext } from './config/launchDarklyContext';
import { LSCommon } from '@legalshield/legalshield-member-react-common';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: envConfig.launchDarklyConfig.clientSideID,
    context: launchDarklyContext,
    options: {
      sendEventsOnlyForVariation: true,
      streaming: true,
    },
    reactOptions: {
      sendEventsOnFlagRead: true,
    },
  });

  const root = document.getElementById('root');
  let renderMethod;
  if (root && root.innerHTML !== '') {
    renderMethod = hydrate;
  } else {
    renderMethod = render;
  }
  const analyticsConfig: AnalyticsOptions = {
    client: AnalyticServiceVendor.GoogleTagManager,
    config: {
      gtmService: envConfig.getGtmVars(),
    },
  };
  const themisAnalytics = new ThemisAnalytics(analyticsConfig);

  themisAnalytics.initialize();

  LSCommon.initApp({
    environment: envConfig.getEnvironment(),
    language: market || 'en-US',
  });

  renderMethod(
    <React.StrictMode>
      <BrowserRouter>
        <LDProvider>
          <App />
        </LDProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  );
})();
